import { resendInvitation, deleteInvitation } from '../userInvitationsHelpers'
import { updateInvitation, removeInvitation } from '../../../actions/companyUsers'

const RecordActions = ({ invitation, userInvitationsUrl, dispatch }) => (
  invitation.invitation_accepted ? '' :
  <span>
    <button className="btn btn-default btn-sm" onClick={e => {
      resendInvitation(e, userInvitationsUrl, invitation.id, inv => dispatch(updateInvitation(inv)))
    }}>Resend</button>&nbsp;
    <button className="btn btn-default btn-delete btn-sm" onClick={e => {
      deleteInvitation(e, userInvitationsUrl, invitation.id, inv => dispatch(removeInvitation(inv)))
    }}>Delete</button>
  </span>
)
const mapStateToProps = ({ userInvitationsUrl }) => ({ userInvitationsUrl })
export default connect(mapStateToProps)(RecordActions)



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/user-invitations/components/RecordActions.js